export default __webpack_public_path__ + "static/Discovering-the-northern-lights-2b5f38ddca4f2b827734def5ae5992e0.jpg";